module.exports = __webpack_public_path__ + "faf24fb4c9ae8c74c5ff31a7f1f4ebd6.MP3";